declare namespace MWY {

    namespace CustomValidation {
        function registerValidationMethods(): void;
    }

    type CustomValidationRule = (element: JQuery) => string;

}